"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndicationsResponseDtoToJSON = exports.IndicationsResponseDtoFromJSONTyped = exports.IndicationsResponseDtoFromJSON = exports.instanceOfIndicationsResponseDto = exports.IndicationsResponseDtoOrderTypeEnum = void 0;
/**
 * @export
 */
exports.IndicationsResponseDtoOrderTypeEnum = {
    Carrier: 'CARRIER',
    CombiCc: 'COMBI_CC',
    CombiCdd: 'COMBI_CDD',
    CombiPd: 'COMBI_PD',
    CombiPfu: 'COMBI_PFU',
    CombiPoc: 'COMBI_POC',
    CombiRpl: 'COMBI_RPL',
    Diagnostic: 'DIAGNOSTIC',
    Exome: 'EXOME',
    Nips: 'NIPS',
    Pathogen: 'PATHOGEN',
    Pgx: 'PGX',
    Preventive: 'PREVENTIVE',
    SmaStat: 'SMA_STAT',
    SolidTumor: 'SOLID_TUMOR',
    Stat: 'STAT',
    TumorProfiling: 'TUMOR_PROFILING',
    Wgs: 'WGS'
};
/**
 * Check if a given object implements the IndicationsResponseDto interface.
 */
function instanceOfIndicationsResponseDto(value) {
    var isInstance = true;
    isInstance = isInstance && "isCancer" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "orderType" in value;
    return isInstance;
}
exports.instanceOfIndicationsResponseDto = instanceOfIndicationsResponseDto;
function IndicationsResponseDtoFromJSON(json) {
    return IndicationsResponseDtoFromJSONTyped(json, false);
}
exports.IndicationsResponseDtoFromJSON = IndicationsResponseDtoFromJSON;
function IndicationsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isCancer': json['isCancer'],
        'name': json['name'],
        'orderType': json['orderType'],
    };
}
exports.IndicationsResponseDtoFromJSONTyped = IndicationsResponseDtoFromJSONTyped;
function IndicationsResponseDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isCancer': value.isCancer,
        'name': value.name,
        'orderType': value.orderType,
    };
}
exports.IndicationsResponseDtoToJSON = IndicationsResponseDtoToJSON;
